exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".sub-frequency-tag[data-v-280043ae] {\n  display: inline-block;\n  border: 2px solid;\n  border-color: #ebebeb;\n  border-radius: 4px;\n  padding: 0.1em 0.3em;\n}\n", ""]);

// exports
